import React from 'react';

const Tabs = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="mb-4 sm:mb-6">
      <div className="">
        <nav className="-mb-px flex overflow-x-auto pb-1">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`py-2 px-4 border-b font-medium text-xs sm:text-sm whitespace-nowrap flex-shrink-0 ${
                activeTab === tab.id
                  ? 'border-brand-500 text-brand-600 pl-1'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              <div className="flex items-center gap-1">
                {activeTab === tab.id && <span className="bg-brand-500 w-2 h-2 flex rounded-full"></span>}
                {tab.label}
              </div>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Tabs; 